import { render, staticRenderFns } from "./ConfigTableExpand.vue?vue&type=template&id=816aae5e&scoped=true"
import script from "./ConfigTableExpand.vue?vue&type=script&lang=js"
export * from "./ConfigTableExpand.vue?vue&type=script&lang=js"
import style0 from "./ConfigTableExpand.vue?vue&type=style&index=0&id=816aae5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "816aae5e",
  null
  
)

export default component.exports